import React from 'react';

import styles from './Network.module.scss';

const Network = (props) => (
  <div className={styles.Network} id={ props.id }>
    <div className={styles.Network__Wrapper}>
      <h2 className="h2">{props.title}</h2>
      <p>{props.text}</p>
      <div className={`${styles.Logos} logos`}>
        {props.logos.map((logo, i) =>
          <a key={i} href={logo.link.link} title={ logo.link.text } className="partner-logo-link" target="_blank"><img src={logo.logo.file.url} alt={logo.logo.title} className={styles.Logo}/></a>
        )}
      </div>
    </div>
  </div>
)

export default Network;



// WEBPACK FOOTER //
// ./src/components/WhatAboutCollege/Network/index.js